/* npm modules outside of vrbo */
import React from 'react';
import {PropTypes} from 'prop-types';

/* Atoms (custom) */
import {CardImage} from '../../atoms/CardImage/CardImage';
import {Typography} from '../../atoms/Typography/Typography';

import './ImageWithStatus.less';

export const ImageWithStatus = ({
    imageUri,
    layout,
    status,
    statusType = 'default',
}) => {
    const statusClass = `label label-${
        statusType === 'black' ? '-black' : statusType
    }`;

    return (
        <div className="ImageWithStatus">
            <CardImage imageUri={imageUri} layout={layout} />
            {status && (
                <div className="ImageWithStatus__status">
                    <Typography
                        className={statusClass}
                        content={status}
                        TagName="div"
                    />
                </div>
            )}
        </div>
    );
};

ImageWithStatus.PropTypes = {
    imageUri: PropTypes.string.isRequired,
    layout: PropTypes.string,
    status: PropTypes.string,
    statusType: PropTypes.string,
};
